import { isMobile } from 'react-device-detect';
import { classes } from 'utils';

import styles from './Container.module.scss';

const Container: React.FC = ({ children }) => {
  return (
    <div className={classes(styles.container, isMobile ? styles.mobile : styles.web)}>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default Container;
